// extracted by mini-css-extract-plugin
module.exports = {"Back":"Multiplayer_Back__3PgxT","Main":"Multiplayer_Main__3-Uxq","Loading":"Multiplayer_Loading__wJA_w"};